import React from "react";
import {
  Grid,
  Box,
  Autocomplete,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { companyWiseEmp } from "../../actions/Companywiseclient";

const DeviceRestoreConfiguration = ({ userList }) => {
  const [selectedUser, setSelectedUser] = React.useState(null);

  const restoreDeviceForUser = async () => {
    if (!Boolean(selectedUser)) {
      alert("Please select an user first");
      return;
    }
    if (window.confirm("Are you sure you want to restore?")) {
      const response = await companyWiseEmp.fetchRestoreDeviceForUser({
        userId: selectedUser?.id,
      });
      if (response && response?.status === 200) {
        alert(response?.data || "Device restored successfully");
        setSelectedUser(null);
      } else {
        const parsedErrMessage =
          response?.response?.data ||
          response?.message ||
          "Something went wrong";
        alert(parsedErrMessage);
      }
    }
  };

  React.useEffect(() => {
    setSelectedUser(null);
  }, [userList]);

  return (
    <Accordion className="main_accoardian" defaultExpanded={true}>
      <AccordionSummary
        className="accordianHeader"
        expandIcon={
          <AddCircleIcon fontSize="large" style={{ color: "white" }} />
        }
        aria-controls="panel1a-content"
        style={{
          background: "rgb(10 166 141)",
          borderRadius: "10px 10px 0px 0px",
          overflow: "hidden",
        }}
      >
        <Grid>
          <h3
            style={{
              color: "#fff",
              marginLeft: "10px",
              padding: "10px 2px",
            }}
          >
            Device Restore Configuration:-
          </h3>
        </Grid>
      </AccordionSummary>
      <AccordionDetails className="accoardian_body">
        <Box sx={{ p: 2 }}>
          <Grid container spacing={3}>
            <Grid item>
              <div className="field_box">
                <Autocomplete
                  size="small"
                  className="select_box_forCompanyWise"
                  limitTags={1}
                  id="multiple-limit-tags"
                  value={selectedUser || null}
                  options={userList}
                  getOptionLabel={(option) =>
                    `${option.name}(${option.empCode})`
                  }
                  disablePortal={true}
                  fullWidth
                  onChange={(event, newValue) => {
                    setSelectedUser(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="dense"
                      placeholder="User"
                    />
                  )}
                />
              </div>
            </Grid>
            {selectedUser && (
              <Grid item>
                <div
                  className="field_box"
                  style={{
                    paddingBottom: "12px",
                  }}
                >
                  <div
                    className="field_box_btn1"
                    style={{
                      cursor: "pointer",
                      paddingLeft: "13px",
                      paddingRight: "13px",
                    }}
                    onClick={restoreDeviceForUser}
                  >
                    Restore Device
                  </div>
                </div>
              </Grid>
            )}
          </Grid>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default DeviceRestoreConfiguration;
